/**
 * @Description: 用于存储标签图标分类的多语言文言内容相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  LabelIconCategoryLanguageModel,
  LabelIconCategoryLanguageSearchModel,
  LabelIconCategoryLanguagePageSearchModel,
  LabelIconCategoryLanguageAddModel,
  LabelIconCategoryLanguageUpdateModel,
  IdsModel
} from '@/model/product/LabelIconCategoryLanguageModel'

const baseUrl = Route.product + '/labelIconCategoryLanguage'

/**
 * 搜索分页数据
 */
export const pageSearchLabelIconCategoryLanguage = (param: LabelIconCategoryLanguagePageSearchModel) => {
  return https().request<RootObject<PageRespModel<LabelIconCategoryLanguageModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchLabelIconCategoryLanguage = (param: LabelIconCategoryLanguageSearchModel) => {
  return https().request<RootObject<LabelIconCategoryLanguageModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getLabelIconCategoryLanguage = (id: number) => {
  return https().request<RootObject<LabelIconCategoryLanguageModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addLabelIconCategoryLanguage = (param: LabelIconCategoryLanguageAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateLabelIconCategoryLanguage = (param: LabelIconCategoryLanguageUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeLabelIconCategoryLanguage = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveLabelIconCategoryLanguage = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
